import request from '@/api/req/request'

/**获取weix*/
export function createInit(url) {
  return request.get('index/share/shareUrl',{
    params: {
      path: url,
      uid: 0
    }
  })
}

/**生成二维码*/
export function createCode(url, i) {
  return request.get('/index/share/shareQrCode',{
    params: {
      path: url,
      uid: 0,
      task_id: i
    }
  })
}

/**复制链接*/
export function createUrl() {
  return request.get('index/share/link',{
  })
}

/**分享的好友*/
export function shareFriend(page) {
  return request.get('index/share/mySharedFriends',{
    params: {
      page
    }
  })
}

/**分享的任务*/
export function shareTask(page) {
  return request.get('index/share/mySharedTasks',{ 
    params: {
      page
    }
  })
}

/**分享的任务*/
export function getUserOpenId(code) {
  return request.get('index/wechat/getWechatToken',{ 
    params: {
      code
    }
  })
}

/** 微信openid */
export function getWechatId(code) {
  return request.get('sns/oauth2/access_token',{ 
    params: {
      appid: 'wxa0ed954a3c87cf1c',
      secret: '470384870867fbd1ab685a4d0ac89ae3',
      code,
      grant_type: 'authorization_code'
    }
  })
}

/** 检测微信自动登录 */
export function getWechatCheck(code) {
  return request.get('/index/wechat/getWechatToken',{ 
    params: {
      code
    }
  })
}

/** 绑定微信手机号码 */
export function bindWechatId(mobile, code, args) {
  return request.post('/index/user/bindOpenid',{ 
      mobile,
      code,
      args
  })
}